export default {
  getPatient (state) {
    return state.currentPatient
  },
  patientProgram: (state, getters) => {
    const { consultantFullName = '' } = state.currentPatient
    const trimConsultantFullNameCheck = !!consultantFullName.trim()

    if (trimConsultantFullNameCheck && getters.patientHasPracticeId) {
      return 'practice_wlp'
    } else {
      if (getters.patientHasPracticeId) {
        return 'practice_general'
      }

      return 'wlp_d2c'
    }
  },
  patientProgramName: (state, getters) => (state.patientProgramOptions.find(program => program.value === getters.patientProgram) || {}).name || '',
  patientHasPracticeId: state => !!state.currentPatient.practiceId,
  getCurrentAdvisorDashboardName: state => state.currentAdvisorDashboardName
}
